import * as React from "react";
import {
  LoaderFunctionArgs,
  redirect,
  useNavigate,
  useParams,
  Outlet,
} from "react-router-dom";
import { useAccount } from "../../Account";
import { SupportedFunctionalityHolder } from "../../SupportedFunctionality";
import AccountGuardianSelector from "./AccountGuardianSelector";

export async function loanHistoryLoader({ request }: LoaderFunctionArgs) {
  console.log("loanHistoryLoader executing");

  const supportedFunctionality = await SupportedFunctionalityHolder.fetchData();

  if (supportedFunctionality.supportsLoanHistory === false) {
    return redirect("/myaccount/summary");
  }

  return {};
}

export const AccountHistoryPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { canViewDependentActivity } = useAccount();

  const handleSelectId = (id?: string): void => {
    if (id) {
      navigate(`/myaccount/history/child/${id}`);
      return;
    }
    navigate(`/myaccount/history`);
    return;
  };

  return (
    <>
      {canViewDependentActivity && (
        <AccountGuardianSelector selectedId={id} onSelect={handleSelectId} />
      )}
      <Outlet />
    </>
  );
};
